import { LargeScreen, SmallScreen } from 'pared/components/responsive'
import { IDirector } from 'pared/data/getDirectors'

import { IDetailGuestKpi } from '../index'
import WebLargeMain from './WebLargeMain'
import WebSmallMain from './WebSmallMain'
import { IOrderBy } from './index'

interface IProps {
  itemizedKpis: IDetailGuestKpi[]
  isTableExpanded: boolean
  onToggleExpansion: () => void
  orderBy: IOrderBy
  setOrderBy: any
  selectedDirector: IDirector | null
}

function Main({
  itemizedKpis,
  isTableExpanded,
  onToggleExpansion,
  orderBy,
  setOrderBy,
  selectedDirector,
}: IProps) {
  return (
    <>
      <LargeScreen>
        <WebLargeMain
          itemizedKpis={itemizedKpis}
          isTableExpanded={isTableExpanded}
          onToggleExpansion={onToggleExpansion}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          selectedDirector={selectedDirector}
        />
      </LargeScreen>
      <SmallScreen>
        <WebSmallMain
          itemizedKpis={itemizedKpis}
          isTableExpanded={isTableExpanded}
          onToggleExpansion={onToggleExpansion}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          selectedDirector={selectedDirector}
        />
      </SmallScreen>
    </>
  )
}

export default Main
